import { FileQuestion, Notebook, ScanLine, Users } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

type Problem = { Icon: LucideIcon; title: string; body: string };

const PROBLEMS: ReadonlyArray<Problem> = [
  {
    Icon: Notebook,
    title: 'Le carnet de dépôts',
    body: "Qui a pris combien, qui a payé, qui doit encore ? Sur un cahier, ça se perd, ça se rature, ça finit en disputes.",
  },
  {
    Icon: Users,
    title: 'Le stock confié invisible',
    body: "Tes produits sont chez des sous-agents, mais ton stock ne le sait pas. Tu ne sais plus ce qui est vendu, ce qui dort, ce qui a disparu.",
  },
  {
    Icon: ScanLine,
    title: "La facture qu'on ne retrouve plus",
    body: "Le partenaire conteste un règlement, mais la facture est introuvable. Sans référence consultable, c'est parole contre parole.",
  },
  {
    Icon: FileQuestion,
    title: 'La marge floue',
    body: "Acheter en consignation chez un grossiste, c'est bien — mais quelle marge réelle, après ce que tu lui dois ? Difficile à suivre à la main.",
  },
];

export default function PartenairesProblemV2() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <SectionLabel>Le vrai problème de la consignation</SectionLabel>
        <h2 className="mt-3 max-w-3xl font-marketing-display text-[clamp(30px,4.4vw,56px)] font-bold leading-[1.02] tracking-[-0.035em] text-charcoal-800">
          Le dépôt-vente sur cahier, <span className="underline-lime">ça finit mal.</span>
        </h2>
        <p className="mt-4 max-w-xl font-marketing-body text-[17px] leading-[1.55] text-charcoal-600">
          Travailler avec des partenaires devrait étendre ta force de vente — pas créer un trou noir
          dans ton stock et ta trésorerie. Quatre problèmes reviennent toujours.
        </p>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {PROBLEMS.map(({ Icon, title, body }) => (
            <div
              key={title}
              className="flex flex-col gap-4 border-2 border-charcoal-800 bg-paper p-6 shadow-neobrutal-4"
            >
              <span className="flex h-12 w-12 items-center justify-center border-2 border-charcoal-800 bg-white text-terracotta-500 shadow-neobrutal-2">
                <Icon className="h-[22px] w-[22px]" strokeWidth={2} aria-hidden="true" />
              </span>
              <h3 className="font-marketing-display text-[19px] font-bold leading-[1.15] tracking-[-0.01em] text-charcoal-800">
                {title}
              </h3>
              <p className="font-marketing-body text-[14px] leading-[1.55] text-charcoal-600">
                {body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
